import { render, staticRenderFns } from "./PptTool.vue?vue&type=template&id=17355191&"
import script from "./PptTool.vue?vue&type=script&lang=js&"
export * from "./PptTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17355191')) {
      api.createRecord('17355191', component.options)
    } else {
      api.reload('17355191', component.options)
    }
    module.hot.accept("./PptTool.vue?vue&type=template&id=17355191&", function () {
      api.rerender('17355191', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/PptTool.vue"
export default component.exports